import {
  Provider,
} from '@angular/core';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import {
  refxFormFieldOptions,
} from '@refx/shared-common';

// Material form fields overrides
export const formFieldOptions: MatFormFieldDefaultOptions = {...refxFormFieldOptions, appearance: 'outline', floatLabel: 'auto'};

/**
 *
 */
export function initializeCustomProviders(): Provider[] {
  return [{provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formFieldOptions}];
}
